.pricingItem {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 280px;
  padding: var(--qs-space-32);
  background: var(--qs-color-surface);
  border: 1px solid var(--qs-color-line);
  border-radius: var(--qs-radius-lg);
  transition: border-color var(--qs-motion-dur-fade) var(--qs-motion-ease-settle), transform var(--qs-motion-dur-fade) var(--qs-motion-ease-settle);

  &:hover {
    border-color: var(--qs-color-line-strong);
    transform: translateY(-4px);
  }

  &.emphasis {
    border: 1.5px solid var(--qs-color-accent);
  }

  @media (max-width: 719px) {
    // Phone: stacked, emphasised item first (decisions.md §34).
    &.emphasis {
      order: -1;
    }
  }
}

.pricingHeader {
  margin-bottom: var(--qs-space-24);
}

.pricingTitle {
  font-size: var(--qs-type-display-s-size);
  line-height: var(--qs-type-display-s-lh);
  margin: 0 0 var(--qs-space-16) 0;
  color: var(--qs-color-text);
}

.pricingPrice {
  display: flex;
  align-items: baseline;
  gap: var(--qs-space-12);
}

.priceAmount {
  font-family: var(--qs-font-display);
  font-style: italic;
  font-size: var(--qs-type-display-l-size);
  line-height: var(--qs-type-display-l-lh);
  color: var(--qs-color-text);
}

.priceToken {
  font-size: var(--qs-type-small-size);
  color: var(--qs-color-text-soft);
}

.pricingFeatures {
  list-style: none;
  padding: 0;
  margin: 0 0 var(--qs-space-32) 0;
  flex: 1;

  li {
    display: flex;
    align-items: center;
    gap: var(--qs-space-8);
    padding: var(--qs-space-12) 0;
    border-bottom: 1px solid var(--qs-color-line);
    color: var(--qs-color-text-soft);
    font-size: var(--qs-type-small-size);

    &::before {
      content: '';
      flex: none;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: var(--qs-color-silver);
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

// Gold is spent once per row, on the emphasised card and its Select Plan (Credits board); the
// others keep a plain hairline. Two classes deep to outrank the button module's hover.
.pricingItem:not(.emphasis) .selectPlan,
.pricingItem:not(.emphasis) .selectPlan:hover {
  border-color: var(--qs-color-line-strong);
}

.pricingAction {
  display: flex;
  flex-direction: column;
  gap: var(--qs-space-16);
}
